<template>
  <RouterView />
</template>

<script setup>
import { useTokenStore } from '@/stores'
import { getHttpsAddress } from '@/utils/index'

const { setToken, setRefreshtoken } = useTokenStore()

onMounted(() => {
  // 获取网址中的token参数的值
  const token = new URL(window.location.href).searchParams.get('token')
  const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')

  getHttpsAddress()

  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6NDAsXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2NjcxMjcyMzI1MyxcInJlbWVtYmVyXCI6dHJ1ZX0iLCJleHAiOjE3NjY3MTI3MjN9._L-wvr8ievcPRpa0aowMjl_z_9tGUrVhGhq6RbNSFc0GlZtLeBPc-wtsn3QU3dbS69DSuTusjrrzS_qp87a6xA'
  // const refreshtoken = 'feca5cdbb9448e752a73f7632b3b6b8e'
  if (token) {
    // 存储token
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  }
})
</script>

<style scoped lang="scss"></style>
